// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const grimmsnarl: PokeData = {
  "id": 861,
  "name": "grimmsnarl",
  "height": 15,
  "weight": 610,
  "base_experience": 255,
  "types": [
    PokeType.DARK,
    PokeType.FAIRY
  ],
  "api_moves": [
    "bite",
    "swagger",
    "fake-out",
    "torment",
    "flatter",
    "fake-tears",
    "bulk-up",
    "hammer-arm",
    "assurance",
    "sucker-punch",
    "dark-pulse",
    "nasty-plot",
    "foul-play",
    "play-rough",
    "confide",
    "power-up-punch",
    "spirit-break",
    "false-surrender"
  ],
  "moves": [
    "bite",
    "flatter",
    "bulk-up",
    "dark-pulse",
    "play-rough",
    "spirit-break",
    "starfall",
    "dark-bargain",
    "dazzling-gleam",
    "night-daze",
    "mist-terrain",
    "snatch",
    "pursuit"
  ],
  "evolution_chain": {
    "id": 451,
    "item": null,
    "species": [
      {
        "name": "impidimp",
        "order": 859,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "morgrem",
        "order": 860,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 859,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "grimmsnarl",
        "order": 861,
        "types": [
          PokeType.DARK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 860,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 91,
    "ability_power": 183
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
